var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './divider.styles';
/**
 * Divider component
 * @csspart base - The component's base wrapper.
 */
export class BlocksDivider extends BlocksElement {
    static { this.styles = styles; }
    render() {
        const componentClassNames = this.componentClassNames('cat-c-divider', {
            'cat-c-divider--md': this.size === 'md',
            'cat-c-divider--lg': this.size === 'lg',
            'cat-c-divider--brand': this.background === 'brand'
        });
        return html ` <hr part="base" class="${componentClassNames}" /> `;
    }
}
__decorate([
    property({ type: String })
], BlocksDivider.prototype, "size", void 0);
__decorate([
    property({ type: String })
], BlocksDivider.prototype, "background", void 0);
if (customElements.get('cat-divider') === undefined) {
    customElements.define('cat-divider', BlocksDivider);
}
